<template>
  <div class="bg-light">
    <div class="words">
      <h2 class="important">Manager</h2>
      <div class="person">
        <p>Steve Walters, CEO &amp; Geologist</p>
        <p class="important">Denver Office</p>
        <p>1001 17th Street, Suite 1050 <br> Denver, CO 80202</p>
        <p class="important">Phone</p>
        <p>720-402-3080</p>
        <br>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Team',
  data() {
    return {

    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.words{
  padding-top: 1rem;
}
</style>



// WEBPACK FOOTER //
// src/components/Team.vue